import React, { FC } from 'react';
import supportCircle from 'images/support.svg';
import * as Sentry from '@sentry/browser'; // Sentry code is temporary and should be removed once we verify support contact relay is working
import { useUserInfo } from 'providers/UserInfoProvider';
import { useTranslator } from '@bluebeam/react-i18n';
import { contactSupport } from 'services/contactSupportService';
import { AppUrl } from '../../constants/appUrl';

const PendoSupportCircle: FC<{}> = () => {
  const { translate } = useTranslator(['pendoSupport']);
  const userInfo = useUserInfo();

  const handlePendoClick = (): void => {
    alert('Pendo is not enabled in this environment.');
  };

  // NODE_ENV and APP_ENV are not used
  // because they are not set correctly in each environment
  const showPendoAlert = (): boolean => {
    return (
      window.location.hostname !== AppUrl.US &&
      window.location.hostname !== AppUrl.DE &&
      window.location.hostname !== AppUrl.SE &&
      window.location.hostname !== AppUrl.AU &&
      window.location.hostname !== AppUrl.UK
    );
  };

  const handleEmailSupport = async () => {
    const usersName = userInfo.getUserFirstAndLastName();

    // Retrieve the form data
    const getSupportForm = document.getElementById('form_container');

    if (!getSupportForm) {
      Sentry.captureException(
        new Error(
          'The email form was triggered, but there was a failure finding #form_container in the pendo widget'
        )
      );
      return;
    }

    const maybeMessage = (
      document.getElementById('email-support-message') as HTMLInputElement
    ).value;
    const maybeSubject = (
      document.getElementById('email-support-subject') as HTMLInputElement
    ).value;

    if (!maybeMessage || !maybeSubject) {
      Sentry.captureException(
        new Error(
          `The email form was triggered, but there was no message (${!!maybeMessage}) and/or subject (${maybeSubject}) found`
        )
      );

      return;
    }

    // Swap the pendo widget from form mode to message display mode:
    getSupportForm.style.display = 'none';
    const afterSubmit = document.getElementById('after_submit');
    const afterSubmitTitle = document.getElementById('after_submit_title');
    const afterSubmitMessage = document.getElementById('after_submit_message');
    const successIcons = document.getElementById('after_submit_success_icons');

    if (
      !afterSubmit ||
      !afterSubmitTitle ||
      !afterSubmitMessage ||
      !successIcons
    ) {
      // This code should never trigger unless changes have been made to the pendo resource center.
      Sentry.captureException(
        new Error(
          'There was an error finding one or more of the status elements'
        )
      );
      return;
    }

    afterSubmit.style.display = 'block';
    afterSubmitTitle.innerHTML = translate('pendoSupport:messageSendingTitle');
    afterSubmitMessage.innerHTML = translate(
      'pendoSupport:messageSendingMessage'
    );

    const contactSupportPayload = {
      name: `${usersName.firstname} ${usersName.lastname}`,
      message: maybeMessage,
      subject: maybeSubject,
    };

    await contactSupport(contactSupportPayload).then((wasSuccess) => {
      if (wasSuccess) {
        successIcons.style.display = 'block';
        afterSubmitTitle.innerHTML = translate('pendoSupport:messageSentTitle');
        afterSubmitMessage.innerHTML = translate(
          'pendoSupport:messageSentDescription'
        );
        return;
      }
      afterSubmitTitle.innerHTML = translate('pendoSupport:messageFailedTitle');
      afterSubmitMessage.innerHTML = translate(
        'pendoSupport:messageFailedDescription'
      );
      Sentry.captureException(
        new Error('There was an error sending the email request to NTS.')
      );
    });
  };

  return (
    <>
      <div
        id="pendo-support-circle"
        className="mr3 cursor-pointer pos-r"
        style={{ zIndex: 0 }}
        {...(showPendoAlert() && {
          onClick: handlePendoClick,
        })}
      >
        <img src={supportCircle} alt="support circle" />
      </div>
      <span
        className="hidden"
        id="manage-email-relay"
        onClick={handleEmailSupport}
      />
    </>
  );
};

export default PendoSupportCircle;
